/** Remove only this project's local auth state, including a stalled refresh. */
export function clearSavedSession(projectUrl: string, stores: Pick<Storage, 'removeItem'>[]) {
  const project = new URL(projectUrl).hostname.split('.')[0];
  if (!project) throw new Error('Session configuration is unavailable. Please retry.');
  const key = `sb-${project}-auth-token`;
  for (const store of stores) {
    for (const suffix of ['', '-code-verifier', '-user']) store.removeItem(key + suffix);
  }
}
